export function InteractionRail() {
  return (
    <div className="interaction-rail" aria-hidden="true">
      <span>Drag to rotate</span>
      <i />
      <span>Scroll to zoom</span>
      <i />
      <span>Switch vehicle view</span>
    </div>
  )
}
